const setActiveTab = (state, payload) => {
  state.activeTabView = payload
}

const resetHostPreferences = (state, uniqueAccessCode) => {
  state.hostPreferences = {}
  state.hostPreferencesAccessCode = uniqueAccessCode
}

const setHostPreferences = (state, { uniqueAccessCode, hostPreferences }) => {
  if (state.hostPreferencesAccessCode !== uniqueAccessCode) return
  state.hostPreferences = hostPreferences
}

export default {
  setActiveTab,
  resetHostPreferences,
  setHostPreferences,
}
